import { create } from 'zustand'
import { CrewDataType } from 'src/types'



interface DataType {
    selectedCrew?: CrewDataType
    step: number

}


interface StoreType extends DataType {
    dispatch: (data: DataType) => void
}


export const useCrewInfo = create<StoreType>((set) => ({
    selectedCrew: undefined,
    step: 1,
    dispatch: (newState: Partial<DataType>) => set((state) => ({ ...state, ...newState })),
}))


